import { message } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { useEffect, useState } from 'react'
import { Props } from '.'
import { fileFile } from '../../uploadfiles/hooks'

export function useSetupHook(props: Props) {
  const { visible, currentEditItem, onSubmitEnd, onCancel, getAddOrderAccept } =
    props
  const [form] = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [uploadFilesList, setUploadFilesList] = useState<fileFile[]>([])
  const resetData = () => {
    setUploadFilesList([])
    form.resetFields()
  }
  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    if (uploadFilesList.length < 1) {
      message.warning('至少上传一个文件')
      return
    }

    setIsLoading(true)
    getAddOrderAccept?.({
      id: currentEditItem?.id ?? new Date().getTime(),
      type: formValues.type,
      uploadFilesList: uploadFilesList,
    })
    setIsLoading(false)
    onSubmitEnd?.()
    resetData()
  }
  const handleModalCancel = () => {
    resetData()
    onCancel?.()
  }
  // 上传文件
  const handleUploadfilesChange = (e: fileFile[]) => {
    setUploadFilesList(e)
    form.setFieldsValue({
      fileList: e,
    })
  }
  useEffect(() => {
    if (visible && currentEditItem) {
      setUploadFilesList(currentEditItem.acceptList)
      form.setFieldsValue({
        fileList: currentEditItem.acceptList,
        type: currentEditItem.type,
      })
    }
    // eslint-disable-next-line
  }, [visible])

  return {
    form,
    isLoading,
    uploadFilesList,
    handleSubmit,
    handleModalCancel,
    handleUploadfilesChange,
  }
}
import { message } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import { useEffect, useState } from 'react'
import { Props } from '.'
import { fileFile } from '../../uploadfiles/hooks'

export function useSetupHook(props: Props) {
  const { visible, currentEditItem, onSubmitEnd, onCancel, getAddOrderAccept } =
    props
  const [form] = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [uploadFilesList, setUploadFilesList] = useState<fileFile[]>([])
  const resetData = () => {
    setUploadFilesList([])
    form.resetFields()
  }
  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    if (uploadFilesList.length < 1) {
      message.warning('至少上传一个文件')
      return
    }

    setIsLoading(true)
    getAddOrderAccept?.({
      id: currentEditItem?.id ?? new Date().getTime(),
      type: formValues.type,
      uploadFilesList: uploadFilesList,
    })
    setIsLoading(false)
    onSubmitEnd?.()
    resetData()
  }
  const handleModalCancel = () => {
    resetData()
    onCancel?.()
  }
  // 上传文件
  const handleUploadfilesChange = (e: fileFile[]) => {
    setUploadFilesList(e)
    form.setFieldsValue({
      fileList: e,
    })
  }
  useEffect(() => {
    if (visible && currentEditItem) {
      setUploadFilesList(currentEditItem.acceptList)
      form.setFieldsValue({
        fileList: currentEditItem.acceptList,
        type: currentEditItem.type,
      })
    }
    // eslint-disable-next-line
  }, [visible])

  return {
    form,
    isLoading,
    uploadFilesList,
    handleSubmit,
    handleModalCancel,
    handleUploadfilesChange,
  }
}
